export const initialState = {
  currentWeatherRequestLocation: {
    lat: null,
    lon: null,
  },
};

// ------------------------------------
// Constants
// ------------------------------------
const WEATHER_UPDATE_VIEWPORT = 'WEATHER_UPDATE_VIEWPORT';

// ------------------------------------

const createAction = (type, payload = undefined, options = {}) => ({
  type,
  payload,
  ...options,
});

// ------------------------------------
// Actions
// ------------------------------------
/* eslint-disable max-len */
export const updateWeatherViewport = (updateWeatherViewportPayload) =>
  createAction(WEATHER_UPDATE_VIEWPORT, updateWeatherViewportPayload);
/* eslint-enable max-len */

// ------------------------------------
// Reducer
// ------------------------------------
// oxlint-disable-next-line default-param-last
export const reducer = (state = initialState, action) => {
  let newState = {};

  switch (action.type) {
    case WEATHER_UPDATE_VIEWPORT: {
      if (!action.payload || !action.payload.viewPortDetails)
        return { ...state };

      newState = { ...state };

      const { viewPortDetails, weatherOnMapCenter } = action.payload;

      const newRequestLocation =
        state.locationOnRouteLoad || viewPortDetails.center;

      if (newRequestLocation && !weatherOnMapCenter) {
        newState.currentWeatherRequestLocation = newRequestLocation;
      }
      if (viewPortDetails.center && weatherOnMapCenter) {
        newState.currentWeatherRequestLocation = viewPortDetails.center;
      }

      return { ...newState };
    }

    default:
      return state;
  }
};
